module.exports = __webpack_public_path__ + "static/dashboard_intro1_en@2x-5d9e9526aedf96476f874bdfdf931f99.png";